// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc447acb","455":"f0342f7a","488":"e0a9c4fb"}[chunkId] + ".chunk.js";
};